var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60078 3.27365C11.0477 3.15819 12.4213 2.58922 13.526 1.64775C16.1041 -0.549252 19.8959 -0.549252 22.474 1.64775C23.5787 2.58922 24.9523 3.15819 26.3992 3.27365C29.7757 3.5431 32.4569 6.2243 32.7263 9.60078C32.8418 11.0477 33.4108 12.4213 34.3522 13.526C36.5493 16.1041 36.5493 19.8959 34.3522 22.474C33.4108 23.5787 32.8418 24.9523 32.7263 26.3992C32.4569 29.7757 29.7757 32.4569 26.3992 32.7263C24.9523 32.8418 23.5787 33.4108 22.474 34.3522C19.8959 36.5493 16.1041 36.5493 13.526 34.3522C12.4213 33.4108 11.0477 32.8418 9.60078 32.7263C6.2243 32.4569 3.5431 29.7757 3.27365 26.3992C3.15819 24.9523 2.58922 23.5787 1.64775 22.474C-0.549252 19.8959 -0.549252 16.1041 1.64775 13.526C2.58922 12.4213 3.15819 11.0477 3.27365 9.60078C3.5431 6.2243 6.2243 3.5431 9.60078 3.27365Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNeutral);
export default __webpack_public_path__ + "static/media/badge_neutral.2800d8ca.svg";
export { ForwardRef as ReactComponent };